import IMask from "imask";
import { __ } from "@wordpress/i18n";

export default class Credit {
  constructor() {
    this.setCardNumberMask();
    this.setCardOwnerMask();
    this.setCardCodeMask();
    this.setCardDateMask();
    this.manageTokenSelect();
  }

  setCardNumberMask() {
    const field = document.querySelector("#wvp-card-number");

    if (field) {
      if (!field.classList.contains("wvp-block-field")) {
        IMask(field, {
          mask: "0000 0000 0000 0000",
        });
      }

      this.handleCardBrand(field);

      field.addEventListener("input", () => {
        this.handleCardBrand(field);
      });
    }
  }

  setCardOwnerMask() {
    const field = document.querySelector("#wvp-card-owner");

    if (field && !field.classList.contains("wvp-block-field")) {
      const mask = IMask(field, {
        mask: /^[A-Za-z\s]*$/,
      });

      field.addEventListener("input", () => {
        field.value = field.value.toUpperCase();
        mask.updateValue();
      });
    }
  }

  setCardDateMask() {
    const field = document.querySelector("#wvp-card-date");

    if (field && !field.classList.contains("wvp-block-field")) {
      IMask(field, {
        mask: "00/00",
      });
    }
  }

  setCardCodeMask() {
    const field = document.querySelector("#wvp-card-code");

    if (field) {
      if (!field.classList.contains("wvp-block-field")) {
        IMask(field, {
          mask: "0000",
        });
      }

      field.addEventListener("input", () => {
        this.setCodeBrand(field);
      });
    }
  }

  handleCardBrand(card) {
    const brands = this.getBrands();
    const number = card.value.replace(/\s/g, "");
    let found;

    if (!number || card.value.length < 16) return;

    this.resetInstallmentsError();

    brands.forEach((brand) => {
      if (brand.regex.test(number) && !found) {
        found = brand;
        this.setCardBrand(brand.name, brand.code);
        this.getCardInstallments();

        return;
      }
    });

    if (!found) {
      this.setCardBrand("mono/generic", 1);
      this.showInstallmentsError();
    }
  }

  showInstallmentsError() {
    const errorList = document.querySelector("#wvp-installments-error");
    if (errorList) {
      errorList.innerText = __(
        "Não foi possível acessar os dados de parcelamento para esta bandeira de cartão.",
        "vindi-pagamentos",
      );
      errorList.classList.add("active");
    }
  }

  resetInstallmentsError() {
    const errorList = document.querySelector("#wvp-installments-error");
    if (errorList) {
      errorList.innerText = "";
      errorList.classList.remove("active");
    }
  }

  getBrands() {
    return [
      {
        code: 16,
        name: "elo",
        regex: /^(401178|401179|431274|438935|451416|457393|457631|457632|504175|506699|5067[0-6][0-9]|506777|506778|509[0-8][0-9]{2}|50999[0-8][0-9]|509999[0-9]|627780|636297|636368|636369|650003[1-3]|650003[5-9]|650004[0-9]|650005[0-1]|650405|650406|650407|650408|650409|650410[5-9]|650411[0-9]|650412[0-9]|650485|650486|650487|650488|650489|650490[0-9]|650491[0-8]|6505[0-8][0-9]|6507[0-6][0-9]|6507[7-8][0-9]|6509[0-8][0-9]{2}|650999[0-8][0-9]|6509999|65165[2-9]|65166[0-9]|655000|655[1-6][0-9]{2}|6557[0-9]{3}|6558[0-9]{3}|6559[0-8][0-9]{2}|655999|655(99[7-9]|9[8-9][0-9])|6504[0-5][0-9]{2}|65047[1-9]|6504[8-9][0-9]|650[5-6][0-9]{3}|6507[0-5][0-9]{2}|6507[8-9][0-9]{2}|650(8[0-4][0-9]{2}|850|86[0-9]{2}|870|88[0-9]{2})|65[1-5][0-9]{4}|65[6-9][0-9]{4}|6516[5-6][0-9]{2}|65167[0-9]|6517[0-8][0-9]{2}|65179[0-8][0-9]{2}|651799)/,
      },
      {
        code: 3,
        name: "visa",
        regex: /^4[0-9]{12}(?:[0-9]{3})?$/,
      },
      {
        code: 4,
        name: "mastercard",
        regex: /^5[1-5][0-9]{14}$|^2[2-7][0-9]{14}$/,
      },
      {
        code: 5,
        name: "amex",
        regex: /^3[47][0-9]{13}$/,
      },
      {
        code: 25,
        name: "hipercard",
        regex: /^(606282|3841\d{2}|60(?!11)\d{2})\d{10}$/,
      },
      {
        code: 20,
        name: "hiper",
        regex: /^(637095|637599|637612|637609|637598)\d*$/,
      },
    ];
  }

  setCardBrand(name, code) {
    const img = document.querySelector("#wvp-brand-icon");
    const hidden = document.querySelector("#wvp-card-brand");

    if (img) {
      const attr = img.getAttribute("data-img");
      if (attr) {
        img.src = img.src.replace(attr, name);
        img.setAttribute("data-img", name);
      }
    }

    if (hidden) {
      hidden.value = code;
    }
  }

  setCodeBrand(code) {
    const img = document.querySelector("#wvp-cvv-icon");
    const brand = code.length < 3 ? "mono/cvv" : "cvv";

    if (img) {
      const attr = img.getAttribute("data-img");
      if (attr) {
        img.src = img.src.replace(attr, brand);
        img.setAttribute("data-img", brand);
      }
    }
  }
  manageTokenSelect() {
    jQuery('input[name="wc-vindi-pagamentos-credit-payment-token"]').on('change', (e) => {
      if (jQuery(e.target).is(':checked') && e.target.value !== 'new') {
        this.getCardInstallments(e.target.value);
      }
      const select = document.querySelector("#wvp-card-installments");
      select.innerHTML = "";
    });
  }

  getCardInstallments(token = null) {
    if (!document.querySelector("#wvp-card-installments")) {
      return;
    }

    const brand = document.querySelector("#wvp-card-brand");
    const nonce = document.querySelector("#wvp-card-nonce");
    const total = document.querySelector("#wvp-cart-total");

    this.resetInstallmentsError();
    this.setRequestLoader();

    const data = {
      price: total.value,
      _wpnonce: nonce.value,
      security: wc_checkout_params.update_order_review_nonce,
    };

    // Use token if provided, otherwise use brand
    if (token) {
      data.token = token;
    } else {
      data.brand = brand.value;
    }

    // Store the current token to check later
    const currentToken = token;

    const xhr = jQuery.ajax({
      url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'checkout_installments'),
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),
      success: function (data) {
        if (data.success) {
          const installments = data.data.installments;
          const select = document.querySelector("#wvp-card-installments");
          const errorList = document.querySelector("#wvp-installments-error");
          if (data.data.message) {
            errorList.textContent = data.data.message;
            errorList.classList.add("active");
          }

          select.innerHTML = "";
          for (const key in installments) {
            const option = document.createElement("option");
            option.value = key;
            option.innerText = installments[key];

            select.appendChild(option);
          }
        }
      },
      error: function (xhr, status, error) {
        if (status !== 'abort') {
          const errorList = document.querySelector("#wvp-installments-error");
          if (errorList && errorList.innerHTML === "") {
            const span = document.createElement("span");

            span.innerText = error.message;
            errorList.appendChild(span);
            errorList.classList.add("active");
          }
        }
      },
      complete: () => {
        jQuery(".wvp-credit-fields").removeClass("processing").unblock();
      },
    });

    // Cancel the request if the token changes
    jQuery('input[name="wc-vindi-pagamentos-credit-payment-token"]').on('change', (e) => {
      if (jQuery(e.target).is(':checked') && e.target.value !== currentToken) {
        xhr.abort();
      }
    });
  }

  setRequestLoader() {
    jQuery(".wvp-credit-fields")
      .addClass("processing")
      .block({
        message: null,
        overlayCSS: {
          background: "#fff",
          opacity: 0.6,
        },
      });
  }
}